// ======================= Imports =======================
import React from "react";
import { Spinner } from "react-activity";
import "react-activity/dist/library.css";

// ======================= Helper =======================
const getRemValue = (rem) => {
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  return rem * rootFontSize; // convert rem → px
};

// ======================= Common Loader Blue Component =======================
export default function CommonLoaderBlue({ customSize, color }) {
  // Convert your numeric "customSize" (intended as rems) into px for Spinner
  const spinnerSizePx = customSize
    ? getRemValue(customSize / 10) // example: 20 → 2rem → px
    : getRemValue(3.2); // default 3.2rem → px

  return <Spinner color={color || "royalblue"} size={spinnerSizePx} />;
}
